module.exports = __webpack_public_path__ + "img/vr-tech.fc77d189.png";